
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Contact() {
  const contactInfo = [
    {
      icon: 'ri-map-pin-line',
      title: 'Address',
      content: 'Room 4029, North JUNYI Business Center, South of Lixin road, Huaide, Fuyong, Baoan district, Shenzhen, Bao\'An, Shenzhen, 518103',
    },
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      content: '+81675387393',
      link: 'tel:+81675387393',
    },
    {
      icon: 'ri-time-line',
      title: 'Business Hours',
      content: 'Monday - Friday: 9:00 AM - 6:00 PM',
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section 
          className="relative bg-cover bg-center h-96 flex items-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 20, 60, 0.7), rgba(0, 20, 60, 0.7)), url('https://public.readdy.ai/ai/img_res/ba5d23a2a29ac27946344fadf8452496.jpg')`
          }}
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full">
            <h1 className="text-5xl font-bold text-white mb-4">Contact Us</h1>
            <p className="text-xl text-gray-200 max-w-2xl">Get in touch with our team to discuss your petroleum logistics needs</p>
          </div>
        </section>

        {/* Contact Info Cards */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              <div className="bg-white rounded-xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow border-2 border-transparent hover:border-teal-500">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Our Location</h3>
                <p className="text-gray-600">
                  Room 4029, North JUNYI Business Center, South of Lixin road, Huaide, Fuyong, Baoan district, Shenzhen, 518103
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow border-2 border-transparent hover:border-teal-500">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-phone-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Phone</h3>
                <a href="tel:+81675387393" className="text-teal-600 hover:text-teal-700 text-lg font-semibold">
                  +81675387393
                </a>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow border-2 border-transparent hover:border-teal-500">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Business Hours</h3>
                <p className="text-gray-600">
                  Monday - Friday: 8:00 AM - 6:00 PM<br />
                  Saturday: 9:00 AM - 2:00 PM
                </p>
              </div>
            </div>

            {/* Contact Information */}
            <div className="max-w-4xl mx-auto">
              <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-2xl p-12 text-white text-center shadow-2xl">
                <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-customer-service-2-line text-4xl text-white"></i>
                </div>
                <h2 className="text-4xl font-bold mb-6">We're Here to Help</h2>
                <p className="text-xl text-blue-100 mb-8 leading-relaxed max-w-2xl mx-auto">
                  Our team of petroleum logistics experts is ready to assist you with storage, shipping, and analysis solutions. Contact us through any of the methods above, and we'll respond within 24 hours.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                      <i className="ri-time-line text-2xl text-white"></i>
                    </div>
                    <h3 className="text-lg font-bold mb-2">24/7 Operations</h3>
                    <p className="text-blue-100 text-sm">Round-the-clock service availability</p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                      <i className="ri-shield-check-line text-2xl text-white"></i>
                    </div>
                    <h3 className="text-lg font-bold mb-2">Trusted Partner</h3>
                    <p className="text-blue-100 text-sm">Decades of industry experience</p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                      <i className="ri-global-line text-2xl text-white"></i>
                    </div>
                    <h3 className="text-lg font-bold mb-2">Global Reach</h3>
                    <p className="text-blue-100 text-sm">International logistics solutions</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-8 text-center">Our Location</h2>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3677.8!2d113.8!3d22.6!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDM2JzAwLjAiTiAxMTPCsDQ4JzAwLjAiRQ!5e0!3m2!1sen!2s!4v1234567890"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="TONCENT Location"
              ></iframe>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
